const HALLOWEEN_QUERY_PARAM = 'halloween';
const SEASON_MONTH_INDEX = 9;
const SEASON_FIRST_DAY = 24;
const SEASON_LAST_DAY = 31;

export function isWithinHalloweenSeason(date: Date): boolean {
    return date.getMonth() === SEASON_MONTH_INDEX
        && date.getDate() >= SEASON_FIRST_DAY
        && date.getDate() <= SEASON_LAST_DAY;
}

export function isHalloweenEasterEggEnabled(): boolean {
    const forcedValue = new URLSearchParams(window.location.search).get(HALLOWEEN_QUERY_PARAM);
    if (forcedValue === '1') {
        return true;
    }
    if (forcedValue === '0') {
        return false;
    }
    return isWithinHalloweenSeason(new Date());
}
